<template>
  <modal
    :show="show"
    modal-classes="fnc-closure-dialog"
    header-classes="fnc-closure-header"
    body-classes="fnc-closure-body"
    :show-footer="false"
    aria-labelledby="fnc-closure-title"
    aria-describedby="fnc-closure-description"
    @close="$emit('close')"
  >
    <div slot="header" class="fnc-closure-heading">
      <span class="fnc-closure-icon"><i class="fas fa-check" aria-hidden="true"></i></span>
      <div>
        <h4 id="fnc-closure-title">FNC clôturée</h4>
        <p>{{ number }}</p>
      </div>
    </div>

    <p id="fnc-closure-description" class="fnc-closure-question">Souhaitez-vous envoyer une copie au fournisseur ?</p>
    <div class="fnc-closure-copy">
      <i class="fas fa-file-pdf" aria-hidden="true"></i>
      <p>La fiche clôturée sera jointe au format PDF. Vous pourrez choisir les destinataires et personnaliser le message avant l’envoi.</p>
    </div>
    <div class="fnc-closure-actions">
      <button type="button" class="btn fnc-closure-later" @click="$emit('close')">Pas maintenant</button>
      <button type="button" class="btn btn-primary fnc-closure-send" @click="$emit('prepare')">
        <i class="fas fa-paper-plane" aria-hidden="true"></i>
        Préparer l’envoi
      </button>
    </div>
  </modal>
</template>

<script>
import { Modal } from 'src/components'

export default {
  name: 'FncClosureModal',
  components: { Modal },
  props: {
    show: Boolean,
    number: { type: String, default: '' }
  }
}
</script>

<style>
.fnc-closure-dialog { max-width: 520px; }
.fnc-closure-dialog .modal-content { border: 0; border-radius: 6px; box-shadow: 0 20px 60px rgba(26, 36, 51, .2); overflow: hidden; }
.fnc-closure-dialog .fnc-closure-header { display: flex; align-items: center; justify-content: flex-start; padding: 18px 22px; border-bottom: 1px solid #eceff3; }
.fnc-closure-header .close { margin-left: auto; order: 2; }
.fnc-closure-heading { display: flex; align-items: center; gap: 12px; }
.fnc-closure-icon { display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 8px; background: #fff1ec; color: #f96332; }
.fnc-closure-heading h4 { margin: 0 0 3px; font-size: 17px; font-weight: 600; color: #2c2c2c; }
.fnc-closure-heading p { margin: 0; font-size: 12px; color: #7c8798; }
.fnc-closure-dialog .fnc-closure-body { padding: 22px; }
.fnc-closure-question { margin: 0 0 16px; font-size: 14px; font-weight: 500; color: #2c2c2c; line-height: 1.5; }
.fnc-closure-copy { display: flex; align-items: flex-start; gap: 12px; padding: 12px 14px; background: #f5f7fa; border: 1px solid #eceff3; border-radius: 6px; color: #7c8798; }
.fnc-closure-copy > i { color: #f96332; margin-top: 3px; }
.fnc-closure-copy p { margin: 0; font-size: 12px; line-height: 1.6; }
.fnc-closure-actions { display: flex; justify-content: flex-end; gap: 10px; border-top: 1px solid #eceff3; margin-top: 20px; padding-top: 16px; }
.fnc-closure-actions .btn { margin: 0; border-radius: 6px; min-height: 40px; padding: 10px 16px; font-size: 12px; font-weight: 600; }
.fnc-closure-actions .fnc-closure-later { background: #fff; color: #67748a; border: 1px solid #dfe4ea; box-shadow: none; }
.fnc-closure-actions .fnc-closure-later:hover { background: #f5f7fa; }
.fnc-closure-send i { margin-right: 6px; }
.fnc-closure-actions .btn:focus-visible { outline: 2px solid #f96332; outline-offset: 3px; }
@media (max-width: 575px) {
  .fnc-closure-dialog { margin: 16px; }
  .fnc-closure-dialog .fnc-closure-header,.fnc-closure-dialog .fnc-closure-body { padding: 18px; }
  .fnc-closure-actions { flex-direction: column-reverse; }
  .fnc-closure-actions .btn { width: 100%; }
}
</style>
